import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const IDS = {
    APPRAISER: 10010,
    ASSISTANT: 10020,
    ATTORNEY: 10030,
    CREDIT_COUNSELOR: 10040,
    FINANCIAL_PLANNER: 10050,
    HOME_INSPECTOR: 10060,
    HOME_STAGER: 10070,
    HOMEOWNERS_INSURANCE_AGENT: 10080,
    MORTGAGE_LENDER: 10090,
    PHOTOGRAPHER: 10100,
    REAL_ESTATE_AGENT: 10110,
    REVERSE_MORTGAGE_COUNSELOR: 10120,
    TITLE_OR_ESCROW_AGENT: 10130,
    TRANSACTION_COORDINATOR: 10140,
    TITLE_SALES_EXEC: 10145,
    OTHER: 10150,
    LOAN_OFFICER: 10090,
    MORTGAGE_SERVICER: 10230,
    HOME_CONCIERGE: 10240,
    HOME_WARRANTY: 10160,
    LEADERSHIP: 10250,
    HOME_SERVICE_PROFESSIONAL: 10260,
};

class LuOrganizationOccupationAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Lu-Organization-Occupation';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/occupations';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at'
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'id',
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default LuOrganizationOccupationAppResource;
